<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col lg="12">
        <b-card
          title="Import des fichiers Codas"
          sub-title="Aperçu des tentatives de réconciliation des fichiers Codas"
          bg-variant="secondary"
        >
          <b-row v-if="loaded && codas.length">
            <b-col lg="12">
              <b-button @click="importCodas()" variant="success"
                >Importer</b-button
              >
              <b-button @click="copyToClipboard()" variant="info" class="ml-3"
                >Copier les extraits à encoder manuellement</b-button
              >
            </b-col>
            <b-col lg="12" class="mt-2">
              <table class="table table-hover table-sm table-responsive">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th class="text-right">Montant</th>
                    <th>N° compte</th>
                    <th>N° compte société</th>
                    <th>Extrait</th>
                    <th>Nom</th>
                    <th>Communication</th>
                    <th>Mandat</th>
                    <th>Débiteur</th>
                    <th>Créancier</th>
                    <th>Import</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(coda, index) in codas"
                    :key="index"
                    :class="
                      coda.matching_status
                        ? 'background-coda' + coda.matching_status
                        : 'background-coda0'
                    "
                  >
                    <td>{{ coda.date }}</td>
                    <td class="text-right">{{ coda.amount }}&nbsp;€</td>
                    <td>{{ coda.number }}</td>
                    <td>{{ coda.societe_number }}</td>
                    <td>{{ coda.bankref }}</td>
                    <td>{{ coda.name }}</td>
                    <td>{{ coda.communication }}</td>
                    <template v-if="coda.matching_infos">
                      <td>
                        <router-link
                          :to="{
                            name: 'warrantView',
                            params: { id: coda.matching_infos.mandat.ID },
                          }"
                          target="_blank"
                        >
                          {{ coda.matching_infos.mandat.ID }}</router-link
                        >
                      </td>
                      <td>
                        <router-link
                          v-if="coda.matching_infos.debiteur.ID"
                          :to="{
                            name: 'debtorView',
                            params: { id: coda.matching_infos.debiteur.ID },
                          }"
                          target="_blank"
                          >{{
                            coda.matching_infos.debiteur.nom_soc.trim() ||
                            coda.matching_infos.debiteur.nom +
                              " " +
                              coda.matching_infos.debiteur.prenom
                          }}</router-link
                        >
                      </td>
                      <td>
                        <router-link
                          :to="{
                            name: 'creditorView',
                            params: { id: coda.matching_infos.creancier.ID },
                          }"
                          target="_blank"
                          >{{
                            coda.matching_infos.creancier.nom_soc
                          }}</router-link
                        >
                      </td>
                      <td>
                        <input
                          @change="checkCoda(index)"
                          type="checkbox"
                          :checked="codas[index].checked"
                        />
                      </td>
                    </template>
                    <template v-else>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col>
              <b-alert show variant="info" :dismissible="false">
                Pas de transactions bancaires en cours
              </b-alert>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import DateTime from "@/services/DateTime.js";
import codas from "@/services/codas.js";
export default {
  name: "ImportCodas",
  data() {
    return {
      codas: [],
      loaded: false,
      busy: false,
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Administration",
          to: { name: "administration" },
        },
        {
          text: "Importation des fichiers Codas",
          active: true,
        },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    copyToClipboard() {
      let text = [];
      this.codas.forEach((el) => {
        if (!el.checked) {
          text.push(el.bankref);
        }
      });
      text = text.join("\n");
      let that = this;
      navigator.clipboard.writeText(text).then(
        function () {
          that.$bvToast.toast("Liste collée dans le presse-papier", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
        },
        function () {
          that.$bvToast.toast("Impossible d'utiliser le presse-papier", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "error",
            autoHideDelay: 2000,
            solid: false,
          });
        }
      );
    },
    checkCoda(index) {
      this.codas[index].checked = !this.codas[index].checked;
    },
    load() {
      this.busy = true;
      codas.list().then((response) => {
        this.codas = response.data.data;
        this.loaded = true;
        this.busy = false;
      });
    },
    importCodas() {
      let process = [];
      this.busy = true;
      this.codas.forEach((el) => {
        process.push({
          transactionID: el.ID,
          to_import: el.checked,
          mandatID: el.matching_infos ? el.matching_infos.mandat.ID : null,
        });
      });
      codas.import(process).then((response) => {
        if(response.data.success) {
          this.$bvToast.toast("Import réussi. Rapport envoyé", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
          this.load();
        } else {
          this.$bvToast.toast("Un erreur s'est produite", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "error",
            autoHideDelay: 2000,
            solid: false,
          });
        }
        this.busy = false;
      });
    },
    toDateTime(d) {
      return DateTime.humanDateTime(d);
    },
    ucfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.background-coda0 {
  background-color: var(--danger);
  color: var(--light);
}
.background-coda1 {
  background-color: var(--light);
  // color: var(--light);
}
.background-coda2 {
  background-color: var(--warning);
}
</style>